"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const loopDisplayValuesByBrandingShowValue = {
    always: 'block',
    hover: 'none'
};
// eslint-disable-next-line complexity
function compileSbsStyleString(branding) {
    var _a;
    const { sbs = {}, mobile: { sbs: sbsMobile = {} } = {} } = branding;
    const { gap, imageBlock = {}, radiobutton = {} } = sbs;
    const { gap: gapMobile, imageBlock: imageBlockMobile = {}, radiobutton: radiobuttonMobile = {} } = sbsMobile;
    const { border = {}, width, height, imageScaleType, loop = {}, underlay = {} } = imageBlock;
    const { width: widthMobile, height: heightMobile } = imageBlockMobile;
    const { checked: borderChecked = {}, unchecked: borderUnchecked = {} } = border;
    const { position, showAfterImage } = radiobutton;
    const { position: positionMobile, showAfterImage: showAfterImageMobile } = radiobuttonMobile;
    const showLoopDesktop = loopDisplayValuesByBrandingShowValue[(_a = loop === null || loop === void 0 ? void 0 : loop.desktop) === null || _a === void 0 ? void 0 : _a.show];
    return `
        {
            ${gap ? `--sbs-gap-desktop: ${gap};` : ''}
            ${gapMobile ? `--sbs-gap-mobile: ${gapMobile};` : ''}
            ${width ? `--sbs-image-container-width-desktop: ${width};` : ''}
            ${height ? `--sbs-image-container-height-desktop: ${height};` : ''}
            ${widthMobile ? `--sbs-image-container-width-mobile: ${widthMobile};` : ''}
            ${heightMobile ? `--sbs-image-container-height-mobile: ${heightMobile};` : ''}
            ${imageScaleType ? `--sbs-image-scale-type: ${imageScaleType};` : ''}
            ${borderChecked.color ? ` --sbs-checked-border-color: ${borderChecked.color};` : ''}
            ${borderChecked.radius ? `--sbs-checked-inner-radius: ${borderChecked.radius};` : ''}
            ${borderChecked.style ? `--sbs-checked-border-style: ${borderChecked.style};` : ''}
            ${borderChecked.width ? `--sbs-checked-border-width: ${borderChecked.width};` : ''}
            ${borderUnchecked.color
        ? ` --sbs-unchecked-border-color: ${borderUnchecked.color};`
        : ''}
            ${borderUnchecked.radius
        ? `--sbs-unchecked-inner-radius: ${borderUnchecked.radius};`
        : ''}
            ${borderUnchecked.style
        ? `--sbs-unchecked-border-style: ${borderUnchecked.style};`
        : ''}
            ${borderUnchecked.width
        ? `--sbs-unchecked-border-width: ${borderUnchecked.width};`
        : ''}
            ${showLoopDesktop ? `--sbs-loop-display-desktop: ${showLoopDesktop};` : ''}
            ${typeof loop.opacity === 'number' ? ` --sbs-loop-opacity: ${loop.opacity};` : ''}
            ${underlay.bg ? `--sbs-underlay-bg: ${underlay.bg};` : ''}
            ${underlay.bgHover ? `--sbs-underlay-bg-hover: ${underlay.bgHover};` : ''}
            ${position ? `--sbs-radiobutton-position: ${position};` : ''}
            ${positionMobile ? `--sbs-radiobutton-position-mobile: ${positionMobile};` : ''}
            ${typeof showAfterImage === 'boolean'
        ? `--sbs-radiobutton-order: ${Number(showAfterImage)};`
        : ''}
            ${typeof showAfterImageMobile === 'boolean'
        ? `--sbs-radiobutton-order-mobile: ${Number(showAfterImageMobile)};`
        : ''}
        }
  `;
}
exports.default = compileSbsStyleString;
